<template>
    <div>
        <Title :title="'网盘管理'" ></Title>
        <div class="table-box">
            <div class="search-box">
                <Button type="primary" @click="addNetdiscModal=true;resetForm('addForm')">新增网盘</Button>
            </div>
            <Table  :columns="columns" :data="all_Netdisc.body"></Table>
            <div  class="page-box" v-if="all_Netdisc.page">
                <Page show-sizer
                      show-total
                      :page-size="all_Netdisc.page.page_size"
                      :current="all_Netdisc.page.current"
                      :total="all_Netdisc.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <Modal
                v-model="addNetdiscModal"
                title="新增网盘"
                width="420"
                :mask-closable="false"
                :loading="loading"
                @on-ok="add('addForm')"
        >
            <div>
                <Form ref="addForm" :model="addForm"  :label-width="100" :rules="formValidate">
                    <FormItem label="网盘名称" prop="name">
                        <Input v-model="addForm.name" placeholder="请输入网盘名称" style="width: 240px" maxlength="15"></Input>
                    </FormItem>
                    <FormItem label="协议" >
                        <Select v-model="addForm.schema"  style="width: 240px">
                            <Option value="http" >http</Option>
                            <Option value="https" >https</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="域名" prop="ip">
                        <Input v-model="addForm.ip" placeholder="如:  domain.com" style="width: 240px"></Input>
                    </FormItem>
                     <FormItem label="上传参数" >
                        <Input v-model="addForm.upload_params" placeholder="请输入上传参数" style="width: 240px" disabled></Input>
                    </FormItem>
                     <FormItem label="状态" >
                         <Select v-model="addForm.status"  style="width: 240px">
                             <Option value="1" >启用</Option>
                             <Option value="2" >禁用</Option>
                         </Select>
                    </FormItem>
                    <FormItem label="分配学院" prop="college_ids">
                        <Select v-model="addForm.college_ids" multiple style="width: 240px">
                            <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注" >
                        <Input v-model="addForm.remarks"
                               placeholder="请输入备注"
                               style="width: 240px"
                               maxlength="200"
                               type="textarea"
                               :autosize="{minRows: 2,maxRows: 5}"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="editNetdiscModal"
                title="编辑网盘"
                width="420"
                :mask-closable="false"
                :loading="loading"
                @on-ok="edit('editForm')"
        >
            <div>
                <Form ref="editForm" :model="editForm"  :label-width="100" :rules="formValidate">
                    <FormItem label="网盘名称" prop="name">
                        <Input v-model="editForm.name" placeholder="请输入网盘名称" style="width: 240px" maxlength="15"></Input>
                    </FormItem>
                    <FormItem label="协议" >
                        <Select v-model="editForm.schema"  style="width: 240px">
                            <Option value="http" >http</Option>
                            <Option value="https" >https</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="域名" prop="ip">
                        <Input v-model="editForm.ip" placeholder="请输入网盘域名" style="width: 240px"></Input>
                    </FormItem>
                    <FormItem label="上传参数" >
                        <Input v-model="editForm.upload_params" placeholder="请输入上传参数" style="width: 240px" disabled></Input>
                    </FormItem>
                    <FormItem label="状态" >
                        <Select v-model="editForm.status"  style="width: 240px">
                            <Option :value="1" >启用</Option>
                            <Option :value="2" >禁用</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="分配学院" prop="college_ids">
                        <Select v-model="editForm.college_ids" multiple style="width: 240px">
                            <Option :value="item.college_id" v-for="(item,idx) in colleges_info" :key="idx">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注" >
                        <Input v-model="editForm.remarks"
                               placeholder="请输入备注"
                               style="width: 240px"
                               maxlength="200"
                               type="textarea"
                               :autosize="{minRows: 2,maxRows: 5}"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import Title from "../../ability/components/title";
    export default {
        name: "Netdisc",
        components: {
            Title,
        },
        data(){
            const validateDomain = (rule, value, callback) => {
                let reg = /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
                if (value === '') {
                    callback(new Error('域名不能为空！'));
                } else if(!reg.test(value)){
                    callback(new Error('请填写正确的域名格式！'));

                }else{
                    callback();
                }
            };
            return{
                data:[],
                addNetdiscModal:false,
                editNetdiscModal:false,
                pri_wpan_id:null,
                loading:true,
                formValidate: {
                    name: [
                        {required: true, message: '网盘名称不能为空', trigger: 'blur'}
                    ],
                    ip: [
                        {required: true, validator: validateDomain, trigger: 'blur'}
                    ],
                    college_ids: [
                        {required: true,type:'array', message: '请选择学院', trigger: 'change'}
                    ],
                },
                addForm:{
                    name:'',
                    schema:'https',
                    ip:'',
                    upload_params:'action=upload',
                    status:'1',
                    college_ids:[],
                    remarks:''
                },
                editForm:{
                    name:'',
                    schema:'https',
                    ip:'',
                    upload_params:'action=upload',
                    status:'2',
                    college_ids:[],
                    remarks:''
                },
                columns: [
                    {
                        title:'ID',
                        key:'id',
                        width:65,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title:'网盘名称',
                        key:'name'
                    },
                    {
                        title:'协议',
                        key:'schema'
                    },
                    {
                        title:'域名',
                        key:'ip'
                    },
                    {
                        title: '创建时间',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title: '更新时间',
                        key: 'mtime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.mtime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title:'备注',
                        key:'remarks'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editNetdiscRow(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteNetdisc(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
                page_num:1,
                page_size:20,
            }
        },
        computed: {
            ...mapState({
                all_Netdisc:state => state.priWpans.all_pri_wpan,
                colleges_info:state => state.colleges.colleges_info
            }),
        },
        methods: {
            ...mapActions({
                getPriWpans: 'priWpans/getPriWpans',
                addPriWpans:'priWpans/addPriWpans',
                delPriWpans:'priWpans/delPriWpans',
                editPriWpans:'priWpans/editPriWpans',
                getColleges:'colleges/getColleges',
            }),
            resetForm (name) {
                this.$refs[name].resetFields();
            },
            changeLoading() {
                this.loading = false;
                this.$nextTick(() => {
                    this.loading = true;
                });
            },
            //新增学院
            add(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.addPriWpans({
                            data:_this.addForm,
                            callback:res =>{
                                if(res.status.code === 2000000){
                                    _this.$Message.success('新增网盘成功')
                                    _this.addNetdiscModal = false
                                    _this.initNetdisc()
                                }else{
                                    _this.$Message.success(res.status.message)
                                }

                            }
                        })
                    } else {
                        return this.changeLoading();
                    }
                })
            },
            edit(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.editPriWpans({
                            data:_this.editForm,
                            pri_wpan_id:_this.pri_wpan_id,
                            callback:res =>{
                                _this.$Message.success('编辑网盘成功')
                                _this.editNetdiscModal = false
                                _this.initNetdisc()
                            }
                        })
                    } else {
                        return this.changeLoading();
                    }
                })
            },
            editNetdiscRow(row){
                this.editNetdiscModal = true
                this.pri_wpan_id = row.id
                this.editForm = {
                    name:row.name,
                    schema:row.schema,
                    ip:row.ip,
                    upload_params:row.upload_params,
                    status:row.status,
                    college_ids:row.colleges.map(_ => _.college_id),
                    remarks:row.remarks
                }
            },
            //删除网盘
            deleteNetdisc(row){
                let _this = this
                this.$Modal.warning({
                    title: `删除网盘${row.name}`,
                    content: '确认要删除此数据吗？删除后不可恢复！',
                    onOk:function(){
                        _this.delPriWpans({
                            pri_wpan_id:row.id,
                            callback:res =>{
                                _this.$Message.success('删除成功！');
                                _this.initNetdisc()
                            }
                        })
                    }
                });
            },
            initNetdisc(){
                let _this = this
                this.getPriWpans({
                    page_num:_this.page_num,
                    page_size:_this.page_size
                })
            },
            currentPage(num){
                this.current = num
                this.initNetdisc()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initNetdisc()
            },
        },
        mounted () {
            this.initNetdisc()
            this.getColleges()
        },
    }
</script>

<style scoped lang="less">
    @import "../style/index";
</style>
